export default "__VITE_ASSET__f4aca7ce__"